import React, {Component} from 'react';
import {withRouter} from "react-router";
import {connect} from "react-redux";

import VignetItem from "./VignetItem";
import Analytics from "../common/Analytics";
import * as overviewActions from "../../actions/overview";
import * as vignetsActions from "../../actions/vignets";
import 'bootstrap-daterangepicker/daterangepicker.css';
import AuthService from '../../lib/AuthService';



class OverviewContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            value: '',
            selectedDateIndex : 0

        };
        this.Auth = new AuthService();
    }

    componentDidMount() {

        //this.getGraphData(this.state.graphDuration);
        this.props.shareData();
        let data1 = {user_id: this.Auth.getProfile().user_id, size: '5', type: 'recent_edit'};
        this.props.allRecentData(data1);
        let data2 = {user_id: this.Auth.getProfile().user_id, size: '5', type: 'most_viewed'};
        this.props.allMostviewedData(data2);


    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props !== nextProps || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {


    }


    render() {

        let recentVignets = this.props.vignetsData ? this.props.vignetsData.recentVignets : undefined;

        let vignetsMostviewed = this.props.vignetsData ? this.props.vignetsData.vignetsMostviewed : undefined;

        //let dashboardGraph = (this.props.overviewData && this.props.overviewData.dashboardGraph) ? this.props.overviewData.dashboardGraph : [];
        let shareData = this.props.overviewData ? this.props.overviewData.shareData : [];

        return (

            <div className="content-tab">

                <div className="tab-content" id="myTabContent">
                    <div className="fade show active" id="user" role="tabpanel" aria-labelledby="user-tab">

                        <Analytics />

                        <div className="tab__content--social">
                            <div className="tab__social--items">
                                <div className="tab__social--img">
                                    <img className="fb-adj" src="assets/images/iconFB.png" alt="Facebook"/>
                                </div>
                                <div className="tab__social--title-count">
                                    <h4>FACEBOOK</h4>
                                    <h3><span id="tab-social-count">{shareData ? shareData.fb_count : '0'}</span></h3>
                                </div>
                            </div>
                            <div className="tab__social--items">
                                <div className="tab__social--img">
                                    <img src="assets/images/iconWhatsapp_overview.png" alt="Whatsapp"/>
                                </div>
                                <div className="tab__social--title-count">
                                    <h4>WHATSAPP</h4>
                                    <h3><span id="tab-social-count">{shareData ? shareData.wa_count : '0'}</span></h3>
                                </div>
                            </div>
                            <div className="tab__social--items">
                                <div className="tab__social--img">
                                    <img src="assets/images/iconQR_overview.png" alt="googleplus"/>
                                </div>
                                <div className="tab__social--title-count">
                                    <h4>QR Code</h4>
                                    <h3><span id="tab-social-count">{shareData ? shareData.qr_count : '0'}</span></h3>
                                </div>
                            </div>
                            <div className="tab__social--items">
                                <div className="tab__social--img">
                                    <img className="oth-adj" src="assets/images/iconOthers.png" alt="other"/>
                                </div>
                                <div className="tab__social--title-count">
                                    <h4>OTHERS</h4>
                                    <h3><span id="tab-social-count">{shareData ? shareData.other_count : '0'}</span>
                                    </h3>
                                </div>
                            </div>
                        </div>

                        <div className="tab__pannel--container">
                            <div className="tab__pannel--dsn">
                                <div className="tab__pannel--header">
                                    <h5>Most Viewed</h5>
                                    <div className="toggle-block">
                                        <button className="icon-lib-list menu-toggle-button"></button>
                                    </div>
                                </div>
                                <ul className="tab__pannel-item--list">
                                    {vignetsMostviewed &&

                                    vignetsMostviewed.map((entry, index) => <VignetItem detail={entry} id={index}/>)

                                    }
                                </ul>
                            </div>

                            <div className="tab__pannel--dsn">
                                <div className="tab__pannel--header">
                                    <h5>Recent Edit</h5>
                                    <div className="toggle-block">
                                        <button className="icon-lib-list menu-toggle-button"></button>
                                    </div>
                                </div>
                                <ul className="tab__pannel-item--list">

                                    {recentVignets &&

                                    recentVignets.map((entry, index) => <VignetItem detail={entry} id={index}/>)

                                    }
                                </ul>
                            </div>
                        </div>

                    </div>

                    <div className="tab-panel fade" id="bandwidth" role="tabpanel"
                         aria-labelledby="bandwidth-tab">

                    </div>


                    <div className="tab-panel fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">

                    </div>


                </div>
            </div>


        )
    }

}

function mapStateToProps(state) {
    return {
        overviewData: state.overview.overviewData,
        vignetsData: state.vignets.vignetsData
    };

}

export default withRouter(connect(mapStateToProps, {
    allRecentData: overviewActions.getRecentVignets,
    allMostviewedData: overviewActions.getMostviewedVignets,
    graphData: overviewActions.getGraphData,
    shareData: overviewActions.getShareData,
    allVignetsProps: vignetsActions.getVignetProps
})(OverviewContainer));


// WEBPACK FOOTER //
// ./src/components/overview/OverviewContainer.js